export const milestones = [
    {
      "ProjectName": "تطوير منظومة فروع البنك",
      "ProjectUID": "ea4f48ae-2274-eb11-8af0-005056921d78",
      "TaskUID": "8ae3aa96-c7e3-eb11-8119-8cec4b201b70",
      "TaskName": "Prepare RMS Licenses",
      "TaskDuration": 0,
      "TaskStartDate": "2021-06-27T17:00:00",
      "TaskFinishDate": "2021-06-27T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 242
    },
    {
      "ProjectName":"تطوير منظومة فروع البنك",
      "ProjectUID":"f3983d67-6574-eb11-8af0-005056921d78",
      "TaskUID": "7db45e1e-e2ed-eb11-8b0b-005056921d78",
      "TaskName": "خدمات ترويجية لخدمات البنك",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-27T17:00:00",
      "TaskFinishDate": "2021-05-27T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": true,
      "TaskStatus": "متوقع التأخير/ملاحظة مهمة",
      "TaskDelay": 273
    },
    {
      "ProjectName": "مقر البنك الجديد",
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "TaskUID": "922db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "دراسة معيارية لأفضل ممارسات الالتزام في قطاع التمويل الأصغر",
      "TaskDuration": 0,
      "TaskStartDate": "2021-02-22T17:00:00",
      "TaskFinishDate": "2021-02-22T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 367
    },
    {
      "ProjectName": "مقر البنك الجديد",
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "TaskUID": "9c2db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": " اللائحة التنظيمية لاعتماد المحافظ التمويلية المعتمدة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-03-16T17:00:00",
      "TaskFinishDate": "2021-03-16T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "تم الاطلاق(مكتمل",
      "TaskDelay": 345
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "TaskUID": "a62db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "سياسة الالتزام المعتمدة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-03-29T17:00:00",
      "TaskFinishDate": "2021-03-29T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 332
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "TaskUID": "b02db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "غجراءات العمل المعتمدة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-04-08T17:00:00",
      "TaskFinishDate": "2021-04-08T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 322
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "TaskUID": "ba2db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": " وثيقة متطلبات الاعمال - منصة التقييم الذاتي المعتمدة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-04-23T17:00:00",
      "TaskFinishDate": "2021-04-23T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 307
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "c42db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "الدليل الارشادي للاطراف ذات العلاقة المعتمد",
      "TaskDuration": 0,
      "TaskStartDate": "2021-04-29T17:00:00",
      "TaskFinishDate": "2021-04-29T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 301
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "ce2db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "دليل حوكمة متابعة الفروع المعتمد",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-07T17:00:00",
      "TaskFinishDate": "2021-05-07T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 293
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "d82db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "مراجعة وتطوير معايير الالتزام ودليل حوكمة وتحديد المستهدفات بناء على مخرجات الدراسة المعيارية ودليل الحوكمة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-07T17:00:00",
      "TaskFinishDate": "2021-05-07T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 293
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "e22db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "اعتماد قائمة التدقيق ونماذج مراجعة متطلبات الالتزام الأخرى",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-18T17:00:00",
      "TaskFinishDate": "2021-05-18T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 282
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "ec2db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "اعتماد المصفوفة والمعايير",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-18T17:00:00",
      "TaskFinishDate": "2021-05-18T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 282
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "f62db91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "الحقيبة التدريبية المعتمدة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-20T17:00:00",
      "TaskFinishDate": "2021-05-20T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 280
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "002eb91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "تطوير قائمة التدقيق ونماذج مراجعة متطلبات الالتزام الأخرى",
      "TaskDuration": 0,
      "TaskStartDate": "2021-06-03T17:00:00",
      "TaskFinishDate": "2021-06-03T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 266
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "1a2eb91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "اعتماد تقرير نتائج تقييم الجهات",
      "TaskDuration": 0,
      "TaskStartDate": "2021-06-21T08:00:00",
      "TaskFinishDate": "2021-06-21T08:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 248
    },
    {
      "ProjectName": "تقديم خدمات استشارية في تصميم سياسة و معايير الالتزام وأدلة الحوكمة والنماذج لأعمال البنك مع الجهات الشريكة",
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "TaskUID": "1c2eb91a-b2d1-eb11-bf59-ec5c68ce65d6",
      "TaskName": "انتهاء المشروع",
      "TaskDuration": 0,
      "TaskStartDate": "2021-06-24T08:00:00",
      "TaskFinishDate": "2021-06-24T08:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 245
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "f2f53bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": " المرحلة الثانية: دراسة معيارية و فهم الوضع الحالي",
      "TaskDuration": 514,
      "TaskStartDate": "2020-11-15T08:00:00",
      "TaskFinishDate": "2021-02-12T10:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2020-11-15T08:00:00",
      "TaskBaseline0StartDate": "2020-11-15T08:00:00",
      "TaskBaseline0FinishDate": "2021-02-11T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "04f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد نماذج مخاطر الإئتمان",
      "TaskDuration": 0,
      "TaskStartDate": "2021-02-11T17:00:00",
      "TaskFinishDate": "2021-02-11T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2021-02-11T17:00:00",
      "TaskBaseline0StartDate": "2021-02-11T17:00:00",
      "TaskBaseline0FinishDate": "2021-02-11T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "18f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد تقرير المتطلبات العمل الشاملة",
      "TaskDuration": 0,
      "TaskStartDate": "2020-12-16T17:00:00",
      "TaskFinishDate": "2020-12-16T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2020-12-16T17:00:00",
      "TaskBaseline0StartDate": "2020-12-16T17:00:00",
      "TaskBaseline0FinishDate": "2020-12-16T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "28f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد تقرير معايير الاساسية للدراسات",
      "TaskDuration": 0,
      "TaskStartDate": "2020-12-03T17:00:00",
      "TaskFinishDate": "2020-12-03T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2020-12-03T17:00:00",
      "TaskBaseline0StartDate": "2020-12-03T17:00:00",
      "TaskBaseline0FinishDate": "2020-12-03T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "3af63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد نتائج تقرير الدراسة معيارية مع أصحاب المصلحة من بنك التنمية الإجتماعية",
      "TaskDuration": 0,
      "TaskStartDate": "2020-12-24T17:00:00",
      "TaskFinishDate": "2020-12-24T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2020-12-24T17:00:00",
      "TaskBaseline0StartDate": "2020-12-24T17:00:00",
      "TaskBaseline0FinishDate": "2020-12-24T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "4cf63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد نتائج الدراسة السوقية المفصلة للشرائح والعملاء المستهدفين",
      "TaskDuration": 0,
      "TaskStartDate": "2020-12-28T17:00:00",
      "TaskFinishDate": "2020-12-28T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2020-12-28T17:00:00",
      "TaskBaseline0StartDate": "2020-12-28T17:00:00",
      "TaskBaseline0FinishDate": "2020-12-28T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "5ef63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد نتائج الدراسة لثلاثة نماذج لتمويل مزاولي العمل الحر",
      "TaskDuration": 0,
      "TaskStartDate": "2020-12-24T17:00:00",
      "TaskFinishDate": "2020-12-24T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2020-12-24T17:00:00",
      "TaskBaseline0StartDate": "2020-12-24T17:00:00",
      "TaskBaseline0FinishDate": "2020-12-24T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "74f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "   اعتماد تقرير الوضع الحالي و التوصيات و المبادرات ذات المكاسب السريعة ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-01-25T17:00:00",
      "TaskFinishDate": "2021-01-25T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2021-01-25T17:00:00",
      "TaskBaseline0StartDate": "2021-01-25T17:00:00",
      "TaskBaseline0FinishDate": "2021-01-25T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "88f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": " اعتماد ٣ نماذج عمل بنظرة عامة و  اختيار نموذج عمل واحد ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-03-04T17:00:00",
      "TaskFinishDate": "2021-03-04T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2021-03-04T17:00:00",
      "TaskBaseline0StartDate": "2021-03-04T17:00:00",
      "TaskBaseline0FinishDate": "2021-03-04T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "مكتمل",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "9ef63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد نموذج أعمال عالي المستوى  ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-03-19T11:00:00",
      "TaskFinishDate": "2021-03-19T11:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-03-18T17:00:00",
      "TaskBaseline0FinishDate": "2021-03-18T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 342
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "b6f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "الحصول على اعتماد البنك للهيكل المقترح",
      "TaskDuration": 0,
      "TaskStartDate": "2021-03-19T10:00:00",
      "TaskFinishDate": "2021-03-19T10:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-03-18T17:00:00",
      "TaskBaseline0FinishDate": "2021-03-18T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 342
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "c8f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد مؤشرات قياس الأداء الرئيسية ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-04-13T11:00:00",
      "TaskFinishDate": "2021-04-13T11:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-04-12T17:00:00",
      "TaskBaseline0FinishDate": "2021-04-12T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 317
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "dcf63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد كتيب المنتجات مخصص لكل شريحة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-04-22T15:00:00",
      "TaskFinishDate": "2021-04-22T15:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-04-15T17:00:00",
      "TaskBaseline0FinishDate": "2021-04-15T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متوقع التأخير/ملاحظة مهمة",
      "TaskDelay": 308
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "f4f63bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد النسخة المطورة لأصحاب المصلحة للموافقة عليها",
      "TaskDuration": 0,
      "TaskStartDate": "2021-03-15T17:00:00",
      "TaskFinishDate": "2021-03-15T17:00:00",
      "TaskPercentCompleted": 100,
      "TaskActualStartDate": "2021-03-15T17:00:00",
      "TaskBaseline0StartDate": "2021-03-15T17:00:00",
      "TaskBaseline0FinishDate": "2021-03-15T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "06f73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد دليل السياسات والإجراءات من رؤساء وحدات العمل والمسؤولين عن عمليات كل وحدة منها ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-06-15T14:00:00",
      "TaskFinishDate": "2021-06-15T14:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-06-22T17:00:00",
      "TaskBaseline0FinishDate": "2021-06-22T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 254
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "1af73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد مصفوفة الصلاحيات المقترحة ومصفوفة راسي  من  رؤساء الأقسام",
      "TaskDuration": 0,
      "TaskStartDate": "2021-07-05T09:00:00",
      "TaskFinishDate": "2021-07-05T09:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-08-01T17:00:00",
      "TaskBaseline0FinishDate": "2021-08-01T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 234
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "2cf73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد نموذج الطلب الإئتماني، تقارير الزيارة، قوائم التدقيق وتقرير المتابعة",
      "TaskDuration": 0,
      "TaskStartDate": "2021-07-14T17:00:00",
      "TaskFinishDate": "2021-07-14T17:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-08-10T17:00:00",
      "TaskBaseline0FinishDate": "2021-08-10T17:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 225
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "3cf73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد فرص الأتمتة و بنية تكنولوجيا و القنوات المطلوبة  لدعم تنفيذ نموذج العمل التشغيلي",
      "TaskDuration": 0,
      "TaskStartDate": "2021-07-09T14:00:00",
      "TaskFinishDate": "2021-07-09T14:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-08-05T17:00:00",
      "TaskBaseline0FinishDate": "2021-08-05T17:00:00",
      "TaskIsCritical": true,
      "TaskStatus": "متأخر",
      "TaskDelay": 230
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "4af73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد الملاحظات للخطة المالية المفصلة للخمس سنوات القادمة بناءً على نموذج العمل المختار ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-07-29T09:00:00",
      "TaskFinishDate": "2021-07-29T09:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-08-23T17:00:00",
      "TaskBaseline0FinishDate": "2021-08-23T17:00:00",
      "TaskIsCritical": true,
      "TaskStatus": "متأخر",
      "TaskDelay": 210
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "5cf73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد تقرير خارطة الطريق ",
      "TaskDuration": 0,
      "TaskStartDate": "2021-09-06T09:00:00",
      "TaskFinishDate": "2021-09-06T09:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-09-27T17:00:00",
      "TaskBaseline0FinishDate": "2021-09-27T17:00:00",
      "TaskIsCritical": true,
      "TaskStatus": "متأخر",
      "TaskDelay": 171
    },
    {
      "ProjectName": "مشروع تطوير نموذج عمل تمويل المنشآت الصغيرة والناشئة",
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "TaskUID": "6ef73bcf-bfcd-eb11-aaa9-bc542fa709ee",
      "TaskName": "اعتماد  الجدول الزمني للخطة التدريبية",
      "TaskDuration": 0,
      "TaskStartDate": "2021-10-05T12:00:00",
      "TaskFinishDate": "2021-10-05T12:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-10-24T17:00:00",
      "TaskBaseline0FinishDate": "2021-10-24T17:00:00",
      "TaskIsCritical": true,
      "TaskStatus": "متأخر",
      "TaskDelay": 142
    },
    {
      "ProjectName": "ArrowArchitectureTemplate",
      "ProjectUID": "a94efbb7-1bff-4e46-9182-afb7c50ee688",
      "TaskUID": "3170f326-ea74-eb11-9ab0-780cb87d9177",
      "TaskName": "&lt;New Milestone&gt;",
      "TaskDuration": 0,
      "TaskStartDate": "2021-05-25T08:00:00",
      "TaskFinishDate": "2021-05-25T08:00:00",
      "TaskPercentCompleted": 0,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": "2021-05-25T08:00:00",
      "TaskBaseline0FinishDate": "2021-05-25T08:00:00",
      "TaskIsCritical": true,
      "TaskStatus": "متأخر",
      "TaskDelay": 275
    },
    {
      "ProjectName": "ArrowProjectTemplate",
      "ProjectUID": "b4c07e98-a349-48c7-9a7e-b5fd856686ed",
      "TaskUID": "0d4e8277-ea69-eb11-9aa8-780cb87d9177",
      "TaskName": "mile stone test",
      "TaskDuration": 0,
      "TaskStartDate": "2020-12-22T00:00:00",
      "TaskFinishDate": "2020-12-22T00:00:00",
      "TaskPercentCompleted": 10,
      "TaskActualStartDate": "2020-12-22T00:00:00",
      "TaskBaseline0StartDate": "2020-12-22T00:00:00",
      "TaskBaseline0FinishDate": "2020-12-22T00:00:00",
      "TaskIsCritical": false,
      "TaskStatus": "متأخر",
      "TaskDelay": 429
    }
  ];